let accessToken = ""

export const setAccessToken = (aToken) => {
    accessToken = aToken
}

export const getAccessToken = () => {
    return accessToken
}